<style src="./style.scss">
</style>

<script lang="ts">
  import Checkbox from "@components/checkbox";

  export let title;
  export let options = [];
  export let handleChange = () => null;
</script>

<div class="danger-zone">
  <h1>{title}</h1>
  {#each options as option, index}
    <div>
      <Checkbox
        label="{option.label}"
        bind:checked="{options[index].checked}"
        id="{option.id}"
        handleChange="{handleChange}" />
    </div>
  {/each}
</div>
